//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import {
  IToastNotification,
  ToastType,
} from '@legacy-components/common/toast-notifications/toastNotificationsModel';

export enum TOAST_NOTIFICATIONS_ACTIONS {
  // This adds a notification that has to be triggered to the toastNotifications state
  ADD_TOAST_NOTIFICATION = 'TOAST_NOTIFICATIONS/ADD_TOAST_NOTIFICATION',

  // This removes a notification that has been triggered from the toastNotifications state
  // This does not remove the notification from the screen. This is automatically called after the toast is triggered
  REMOVE_TOAST_NOTIFICATION = 'TOAST_NOTIFICATIONS/REMOVE_TOAST_NOTIFICATION',

  // This adds a notification that has to be removed from the screen to the toastNotificationsToClose state
  CLOSE_TOAST_NOTIFICATION = 'TOAST_NOTIFICATIONS/CLOSE_TOAST_NOTIFICATION',

  // This removes a notification that has been removed from the screen from the toastNotificationsToClose state
  // This is automatically called after the toast is closed
  REMOVE_CLOSED_TOAST_NOTIFICATION = 'TOAST_NOTIFICATIONS/REMOVE_CLOSED_TOAST_NOTIFICATION',
}

export enum ALTERNATE_TOASTS {
  NEW_TOAST = '@legacy-components/common/toast-notifications/templates/new-toast.html',
  PLAIN_TOAST = '@legacy-components/common/toast-notifications/templates/plain-toast.html',
  INFO_TOAST = '@legacy-components/common/toast-notifications/templates/info-toast.html',
}

export const GENERIC_FAILED_TO_DOWNLOAD_TOAST: IToastNotification = {
  options: {
    toastTemplate: ALTERNATE_TOASTS.NEW_TOAST,
  },
  message: `There was an error downloading the requested data. Try again with a different date range or contact Bazaarvoice Support.`,
  title: 'Failed to Download Data',
  type: ToastType.ERROR,
};

export const GENERIC_FAILED_TO_FETCH_DATA_TOAST: IToastNotification = {
  options: {
    toastTemplate: ALTERNATE_TOASTS.NEW_TOAST,
  },
  message: `There was an error fetching the requested data. Try again with a different date range or contact Bazaarvoice Support.`,
  title: 'Failed to Fetch Data',
  type: ToastType.ERROR,
};

export type LegacyToastTemplateType = 'directives/toast/simplebar.html';

/**
 * These are very old toasts used to indicate a successful media upload in
 * the content drawer and the universal image overlay.
 */
export const LEGACY_TOAST_OPTIONS = {
  DEFAULT_TOAST_OPTIONS: {
    closeButton: true,
    tapToDismiss: false,
    toastTemplate: 'directives/toast/simplebar.html',
  },
  STICKY_TOAST_OPTIONS: {
    timeOut: 0,
    closeButton: true,
    extendedTimeOut: 0,
    tapToDismiss: false,
    toastTemplate: 'directives/toast/simplebar.html',
  },
} as const;
